
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estoque",
      function () {
        return require("private-next-pages/estoque/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estoque"])
      });
    }
  